import { useState } from "react";
import api from "@/lib/api";
import { CARD, LBL, ExpBtn, fmtAht, fq, downloadPost, fmtNum } from "./axiom";

export const ExportTab = ({ filters }) => {
  const [busy, setBusy] = useState(null);

  const run = async (key, fn) => { setBusy(key); await fn(); setBusy(null); };

  const dashboardExcel = () => run("dash", async () => {
    const { data } = await api.get(`/aht/dashboard?${fq(filters)}`);
    const sheet = (name, rows) => ({ name, columns: [name, "Calls", "AHT (s)"], rows: rows.map((r) => [r.name, r.calls, Math.round(r.aht)]) });
    await downloadPost("/aht/export/excel", { filename: "AHT_Dashboard.xlsx", sheets: [sheet("By LOB", data.lob_comparison), sheet("By Category", data.by_category), sheet("By Language", data.by_lang), sheet("By Location", data.by_location)] }, "AHT_Dashboard.xlsx");
  });
  const dateExcel = () => run("date", async () => {
    const { data } = await api.get(`/aht/date-analysis?${fq(filters)}`);
    await downloadPost("/aht/export/excel", { filename: "AHT_Date_Analysis.xlsx", sheets: [{ name: "By Date", columns: ["Date", "Calls", "AHT (s)"], rows: data.rows.map((r) => [r.date, r.calls, Math.round(r.aht)]) }] }, "AHT_Date_Analysis.xlsx");
  });
  const datePpt = () => run("dateppt", async () => {
    const { data } = await api.get(`/aht/date-analysis?${fq(filters)}`);
    await downloadPost("/aht/export/simple-ppt", {
      title: "AHT Date Analysis", subtitle: `${data.rows.length} days · avg ${fmtAht(data.avg)}`,
      chart: { type: "line", x: data.rows.map((r) => r.date), series: { "AHT (s)": data.rows.map((r) => r.aht) } },
      table: { name: "AHT by Date", columns: ["Date", "Calls", "AHT"], rows: data.rows.map((r) => [r.date, r.calls, fmtAht(r.aht)]) },
    }, "AHT_Date_Analysis.pptx");
  });
  const trendsExcel = () => run("trends", async () => {
    const { data } = await api.get(`/aht/trends?${fq(filters)}`);
    const tbl = (name, rows) => ({ name, columns: ["Name", ...data.months.map((m) => `${m} (s)`), "Δ (s)", "Calls"], rows: rows.map((r) => [r.name, ...data.months.map((m) => (r.cells[m] != null ? Math.round(r.cells[m]) : "")), r.delta != null ? Math.round(r.delta) : "", r.calls]) });
    await downloadPost("/aht/export/excel", { filename: "AHT_Trends.xlsx", sheets: [tbl("LOB Monthly", data.lob_table), tbl("Category Monthly", data.cat_table)] }, "AHT_Trends.xlsx");
  });
  const trendsPpt = () => run("trendsppt", async () => {
    const { data } = await api.get(`/aht/trends?${fq(filters)}`);
    await downloadPost("/aht/export/simple-ppt", {
      title: "AHT Monthly Trends", subtitle: `${data.months.length} months`,
      chart: { type: "line", x: data.months, series: { Overall: data.overall.map((o) => o.aht) } },
      table: { name: "LOB Monthly", columns: ["LOB", ...data.months], rows: data.lob_table.map((r) => [r.name, ...data.months.map((m) => fmtAht(r.cells[m]))]) },
    }, "AHT_Trends.pptx");
  });
  const benchPpt = () => run("bench", () => downloadPost(`/aht/export/benchmark-ppt?${fq(filters)}`, {}, "AHT_Benchmarking.pptx"));

  const items = [
    ["Dashboard — Excel", "All dashboard breakdowns (LOB, Category, Language, Location)", dashboardExcel, "dash", "purple"],
    ["Date Analysis — Excel", "Daily AHT and call volumes", dateExcel, "date", "purple"],
    ["Date Analysis — PowerPoint", "Daily trend chart + data table deck", datePpt, "dateppt", "indigo"],
    ["Trends — Excel", "LOB & Category monthly trend tables", trendsExcel, "trends", "purple"],
    ["Trends — PowerPoint", "Monthly trend deck", trendsPpt, "trendsppt", "indigo"],
    ["Benchmark — PowerPoint", "Full benchmark deck: exec summary, trends, heatmaps, insights", benchPpt, "bench", "indigo"],
  ];

  return (
    <div>
      <h2 className="font-heading mb-2 text-xl font-bold text-thstrong">Export Center</h2>
      <p className="mb-6 text-sm text-thmute">All exports respect your current global filters.</p>
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map(([title, desc, fn, key, color]) => (
          <div key={key} className={`${CARD} flex flex-col p-5`}>
            <p className="text-sm font-bold text-thstrong">{title}</p>
            <p className="mt-1 flex-1 text-xs text-thdim">{desc}</p>
            <div className="mt-4"><ExpBtn testId={`aht-export-${key}`} onClick={fn} busy={busy === key} color={color}>Export</ExpBtn></div>
          </div>
        ))}
      </div>
      <p className={`${LBL} mt-8`}>Agent exports (all calls, per-category XLSX, agents table) are available on the Agents tab.</p>
    </div>
  );
};
